import { PRODUCT_TYPES } from '@utils/enums';
import { nanoid } from 'nanoid';

const CartItems = class {
	items = [];

	constructor(newItems) {
		this.items = newItems;
	}

	static inferProductType(item) {
		let productType = 'Lens';
		if (item.product_type.includes(PRODUCT_TYPES.BASE_FRAME)) {
			productType = 'Base';
		} else if (item.product_type.includes(PRODUCT_TYPES.TOP_FRAME)) {
			productType = 'Top';
		}
		return productType;
	}

	groupItemsByKey() {
		const itemGroups = {};
		this.items.forEach(item => {
			if (!('properties' in item)) {
				return;
			}

			const bundleKey = item.properties?._bundle_key ?? nanoid();

			try {
				if (itemGroups[bundleKey]) {
					itemGroups[bundleKey].push(item);
				} else {
					// first of bundle to appear
					itemGroups[bundleKey] = [item];
				}
			} catch (error) {
				const itemKey = nanoid();
				itemGroups[itemKey] = [item];
			}
		});
		return itemGroups;
	}

	sortItemGroups() {
		const itemGroups = this.groupItemsByKey();
		const sortedGroups = {};
		const entries = Object.entries(itemGroups);

		for (let [key, itemGroup] of entries) {
			const order = ['Base', 'Lens', 'Top'];
			itemGroup.sort((a, b) => {
				return order.indexOf(CartItems.inferProductType(a)) - order.indexOf(CartItems.inferProductType(b));
			});

			sortedGroups[key] = itemGroup;
		}

		return sortedGroups;
	}

	splitItemGroups() {
		const itemGroups = this.sortItemGroups();
		const splitGroups = {};
		const baseGroups = {};
		const otherGroups = {};
		const itemGroupsCopy = {};
		const sortedKeys = Object.keys(itemGroups).sort();
		sortedKeys.forEach(key => itemGroupsCopy[key] = itemGroups[key]);
		const entries = Object.entries(itemGroupsCopy);

		for (let [key, itemGroup] of entries) {
			if (itemGroup.some(item => item.product_type === 'BASE_FRAME')) {
				baseGroups[key] = itemGroup;
			} else {
				const otherKeys = Object.keys(otherGroups);
				otherKeys.length ? otherGroups[otherKeys[0]].push(...itemGroup) : (otherGroups[key] = itemGroup);
			}
		}

		splitGroups.bases = baseGroups;
		splitGroups.others = otherGroups;
		return splitGroups;
	}
};

export default CartItems;
